import FormGrid from "../components/form/formGrid";
import { useRoutePermissions } from "../helpers";
import { UserPermissionFlags } from "../models/permissions";

export default function FormsPage() {
    useRoutePermissions(UserPermissionFlags.FormsPrint);

    return <FormGrid />;
}
